// This allows us to add custom data to the instance of Error
// Useful in cases when error needs to be thrown to stop execution without calling globalHandleError
export const ErrorCustomDataSymbol = Symbol('ErrorCustomData');
